import { Plan } from '@smarty-nx/data'
import orderBy from 'lodash/orderBy'

export const plansToHide: string[] = []

// TODO Rewrite or get rid of this - https://smarty-mobile.atlassian.net/browse/DIGDEV-11550
export const simInHandFiftyGBHide = ['SM_50GB']

export const hideTempPlans = (plan: Plan, isSIHJourney?: boolean) => {
  if (isSIHJourney) {
    return !simInHandFiftyGBHide.includes(plan.id)
  }
  return !plansToHide.includes(plan.id)
}

export const getOfferName = (plan: Plan): string => {
  if (plan?.voucher) {
    const {
      voucher: { multiple_offers, offer_chip_text },
    } = plan
    return multiple_offers
      ? multiple_offers?.map((offer) => offer.tag).join('|')
      : offer_chip_text
  }

  if (plan?.planHasDataDiscount) {
    return `Up to £${plan?.dataAllowanceGB} back`
  }

  return 'no offer'
}

export const getDiscountValue = ({ originalPrice, finalPrice }: Plan): number =>
  +(originalPrice.value - finalPrice.value).toFixed(2)

export const getPlansSortedByPrice = (
  plans: Plan[],
  order: 'asc' | 'desc' | boolean = 'asc'
) => orderBy(plans, ['originalPrice.value'], [order])

export const getPlansSortedByData = (
  plans: Plan[],
  order: 'asc' | 'desc' | boolean = 'asc'
) =>
  orderBy(
    plans,
    [(plan: Plan) => plan.dataAllowanceWithPromosGB ?? Infinity],
    [order]
  )
